import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceForm from '../../Invoices/components/InvoiceForm';
import DetailsPageActionButtons from '../components/DraftDetailsPageActions';
import { useGetInvoiceHandler } from '../../Invoices/dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function DraftsInvoiceDetailsPage() {
  useDocumentTitle('Invoice Details');
  const { document_id } = useParams();
  const navigate = useNavigate();

  const { invoice, isLoading } = useGetInvoiceHandler(document_id);
  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/drafts?tab=invoices');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Invoice Details" subTitle={invoice?.document_id}>
          <DetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <InvoiceForm onSubmit={() => {}} onCancel={() => {}} initialData={invoice} readOnly={true} />
    </Stack>
  );
}
